import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../services/AuthContext";
import Loading from "./Loading";

const isGuestSessionUser = (userValue) => {
  if (userValue?.isGuest === true) return true;
  return [
    userValue?.loginIdentifier,
    userValue?.email,
    userValue?.username,
  ].some((value) => {
    const normalized = String(value || "").trim().toLowerCase();
    return (
      normalized.startsWith("invitadoo") ||
      normalized.endsWith("@guest.xima.local")
    );
  });
};

const PublicRoute = ({ component: Component, restricted, allowGuest = false, ...rest }) => {
  const { user, loading } = useAuth();
  const normalizedRole = String(user?.role || "")
    .trim()
    .toLowerCase();

  // Wait for the loading to complete
  if (loading) {
    return <Loading />;
  }

  // If user is authenticated and the route is restricted, redirect them to their dashboard
  if (user && restricted && !(allowGuest && isGuestSessionUser(user))) {
    if (
      normalizedRole === "admin" ||
      normalizedRole === "user" ||
      normalizedRole === "superuser"
    ) {
      return <Navigate to="/game/lobby" />;
    } else if (["member", "owner", "manager"].includes(normalizedRole)) {
      return <Navigate to="/owner/dashboard" />;
    }
  }

  // Otherwise, render the component for public routes
  return <Component {...rest} />;
};

export default PublicRoute;
